import React from 'react';

import { Flex } from '../../../../../components';
import { DeviceData } from '../../../../../types';

type ColorRowProps = {
  data: DeviceData;
};

export const ColorRow = ({ data }: ColorRowProps): React.JSX.Element => (
  <div className="flex items-center justify-start gap-[5px] h-[40px]">
    {data.color === 'white' ? (
      <Flex itemAlign="center" justifyContent="flex-start" gap="5px">
        <div className="flex items-center justify-center w-4 h-4 border border-black bg-white rounded-full" />
      </Flex>
    ) : (
      <Flex itemAlign="center" justifyContent="flex-start" gap="5px">
        <div className="flex items-center justify-center w-4 h-4 border border-black bg-black rounded-full" />
      </Flex>
    )}
  </div>
);
